import React from 'react';

import './LandingPage.css';

const brands = [
  { name: 'CRIE CONECTA', logo: 'CrieConecta' },
  { name: 'XtendsTV', logo: 'XtendsTV' },
  { name: 'Smyrna Records', logo: 'Smyrna Records' },
  { name: 'MessageCast', logo: 'MessageCast' },
  { name: 'StartFy', logo: 'StartFy' }
];

export default function LandingPage() {
  return (
    <main className="landing-root">
      {/* HERO NOVO */}
      <header className="landing-hero hero-v2">
        <div className="inner hero-v2-inner">
          <div className="hero-v2-left">
            <h1 className="hero-v2-title">
              O gerador de QR code versátil
            </h1>
            <p className="hero-v2-lead">
              Com nossa plataforma personalizável, você pode centralizar o gerenciamento de seus QR codes em um só local.
            </p>
            <a className="btn primary hero-v2-cta" href="/qrcode-generator">
              Gerar QR code
            </a>
            <ul className="hero-v2-benefits">
              <li>
                <span className="benefit-icon" aria-hidden="true">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="9" fill="white" opacity="0.2"/>
                    <path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                Crie QR codes dinâmicos e editáveis
              </li>
              <li>
                <span className="benefit-icon" aria-hidden="true">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="9" fill="white" opacity="0.2"/>
                    <path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                Monitoramento e análise de seus QR codes
              </li>
              <li>
                <span className="benefit-icon" aria-hidden="true">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="10" cy="10" r="9" fill="white" opacity="0.2"/>
                    <path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                Gere QR codes com logotipos, cores personalizados e muito mais
              </li>
            </ul>
          </div>
          <div className="hero-v2-right">
            <div className="hero-v2-qrbox">
              {/* QR code estilizado */}
              {/* Elementos flutuantes */}
              <div className="qr-float qr-float-palette">
                <svg width="36" height="36" viewBox="0 0 36 36"><rect x="4" y="4" width="28" height="28" rx="6" fill="#fff" stroke="#dbeafe" strokeWidth="2"/><rect x="8" y="8" width="8" height="8" rx="2" fill="#e0e7ff"/><rect x="20" y="8" width="8" height="8" rx="2" fill="#fef3c7"/><rect x="8" y="20" width="8" height="8" rx="2" fill="#bae6fd"/><rect x="20" y="20" width="8" height="8" rx="2" fill="#fbcfe8"/></svg>
              </div>
              <div className="qr-float qr-float-analytics">
                <svg width="36" height="36" viewBox="0 0 36 36"><rect x="4" y="4" width="28" height="28" rx="6" fill="#fff" stroke="#dbeafe" strokeWidth="2"/><path d="M10 26c2-4 4-8 8-8s6 4 8 8" stroke="#38bdf8" strokeWidth="2" fill="none"/><text x="18" y="22" textAnchor="middle" fontSize="10" fill="#222">134</text></svg>
              </div>
              <div className="qr-float qr-float-qrs">
                <svg width="60" height="20" viewBox="0 0 60 20"><rect x="0" y="0" width="12" height="12" rx="2" fill="#bae6fd"/><rect x="16" y="0" width="12" height="12" rx="2" fill="#fbcfe8"/><rect x="32" y="0" width="12" height="12" rx="2" fill="#e0e7ff"/><rect x="48" y="0" width="12" height="12" rx="2" fill="#fef3c7"/></svg>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* SLIDER DE MARCAS */}
      <section className="brand-slider">
        <div className="brand-slider-inner">
          {brands.map((b, i) => (
            <span className="brand-logo" key={b.name + i}>{b.logo}</span>
          ))}
        </div>
      </section>

      {/* COMO FUNCIONA - VISUAL COM SCREENSHOTS */}
      <section id="como-funciona" className="section-how-visual">
        <div className="inner">
          <div className="how-visual-header">
            <h2 className="how-visual-title">Gerar seu próprio QR Code nunca foi tão fácil!</h2>
            <p className="how-visual-subtitle">
              Crie QR Codes profissionais em 3 passos simples. Veja como é intuitivo e rápido:
            </p>
          </div>

          {/* Step 1 - Escolha o Tipo */}
          <div className="how-visual-step">
            <div className="how-visual-content">
              <div className="how-visual-number">01</div>
              <h3 className="how-visual-step-title">Escolha o tipo de QR Code</h3>
              <p className="how-visual-step-desc">
                Selecione entre mais de 12 tipos diferentes: URL, Email, WhatsApp, WiFi, vCard, Texto, SMS e muito mais. 
                Cada tipo foi pensado para facilitar sua necessidade específica.
              </p>
              <ul className="how-visual-features">
                <li>✨ Interface intuitiva e limpa</li>
                <li>🎯 12+ tipos de QR Code disponíveis</li>
                <li>⚡ Geração instantânea</li>
              </ul>
            </div>
            <div className="how-visual-screen">
              {/* Mockup da interface - Seleção de tipo */}
              <svg width="360" height="280" viewBox="0 0 360 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* Background da tela */}
                <rect width="360" height="280" rx="16" fill="#ffffff"/>
                <rect width="360" height="280" rx="16" stroke="#e0e7ff" strokeWidth="3"/>
                
                {/* Header */}
                <rect y="0" width="360" height="50" rx="16" fill="url(#headerGrad1)"/>
                <text x="20" y="30" fill="#1f6cd5" fontWeight="700" fontSize="18">Criar QR Code</text>
                
                {/* Grid de tipos */}
                <g transform="translate(20, 70)">
                  {/* URL - Selected */}
                  <rect x="0" y="0" width="100" height="80" rx="12" fill="#e0f2fe" stroke="#1a73e8" strokeWidth="3"/>
                  <text x="50" y="35" textAnchor="middle" fontSize="28">🔗</text>
                  <text x="50" y="60" textAnchor="middle" fill="#1a73e8" fontWeight="600" fontSize="13">URL</text>
                  
                  {/* Email */}
                  <rect x="110" y="0" width="100" height="80" rx="12" fill="#f8fafc" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="160" y="35" textAnchor="middle" fontSize="28">📧</text>
                  <text x="160" y="60" textAnchor="middle" fill="#64748b" fontWeight="500" fontSize="13">Email</text>
                  
                  {/* WhatsApp */}
                  <rect x="220" y="0" width="100" height="80" rx="12" fill="#f8fafc" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="270" y="35" textAnchor="middle" fontSize="28">💬</text>
                  <text x="270" y="60" textAnchor="middle" fill="#64748b" fontWeight="500" fontSize="13">WhatsApp</text>
                  
                  {/* WiFi */}
                  <rect x="0" y="90" width="100" height="80" rx="12" fill="#f8fafc" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="50" y="125" textAnchor="middle" fontSize="28">📶</text>
                  <text x="50" y="150" textAnchor="middle" fill="#64748b" fontWeight="500" fontSize="13">WiFi</text>
                  
                  {/* vCard */}
                  <rect x="110" y="90" width="100" height="80" rx="12" fill="#f8fafc" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="160" y="125" textAnchor="middle" fontSize="28">👤</text>
                  <text x="160" y="150" textAnchor="middle" fill="#64748b" fontWeight="500" fontSize="13">vCard</text>
                  
                  {/* Texto */}
                  <rect x="220" y="90" width="100" height="80" rx="12" fill="#f8fafc" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="270" y="125" textAnchor="middle" fontSize="28">📝</text>
                  <text x="270" y="150" textAnchor="middle" fill="#64748b" fontWeight="500" fontSize="13">Texto</text>
                </g>
                
                {/* Gradiente header */}
                <defs>
                  <linearGradient id="headerGrad1" x1="0" y1="0" x2="360" y2="0">
                    <stop offset="0%" stopColor="#f0f9ff"/>
                    <stop offset="100%" stopColor="#e0f2fe"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>

          {/* Step 2 - Personalize */}
          <div className="how-visual-step reverse">
            <div className="how-visual-content">
              <div className="how-visual-number">02</div>
              <h3 className="how-visual-step-title">Personalize do seu jeito</h3>
              <p className="how-visual-step-desc">
                Adicione suas cores, escolha o formato dos pontos e olhos do QR Code, insira seu logo e selecione 
                entre dezenas de templates exclusivos. Deixe sua marca!
              </p>
              <ul className="how-visual-features">
                <li>🎨 Paleta de cores ilimitada</li>
                <li>🖼️ Upload de logo personalizado</li>
                <li>✨ 20+ templates prontos</li>
              </ul>
            </div>
            <div className="how-visual-screen">
              {/* Mockup da interface - Personalização */}
              <svg width="360" height="280" viewBox="0 0 360 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="360" height="280" rx="16" fill="#ffffff"/>
                <rect width="360" height="280" rx="16" stroke="#e0e7ff" strokeWidth="3"/>
                
                {/* Header */}
                <rect y="0" width="360" height="50" rx="16" fill="url(#headerGrad2)"/>
                <text x="20" y="30" fill="#1f6cd5" fontWeight="700" fontSize="18">Personalização</text>
                
                {/* Preview do QR Code centralizado */}
                <g transform="translate(120, 70)">
                  <rect x="0" y="0" width="120" height="120" rx="12" fill="#f8fafc" stroke="#e0e7ef" strokeWidth="2"/>
                  {/* QR Code simplificado com gradiente */}
                  <rect x="10" y="10" width="100" height="100" rx="4" fill="url(#qrGrad)"/>
                  <rect x="20" y="20" width="25" height="25" rx="3" fill="#ffffff"/>
                  <rect x="75" y="20" width="25" height="25" rx="3" fill="#ffffff"/>
                  <rect x="20" y="75" width="25" height="25" rx="3" fill="#ffffff"/>
                  <circle cx="60" cy="60" r="15" fill="#ffffff"/>
                </g>
                
                {/* Opções de personalização */}
                <g transform="translate(20, 210)">
                  {/* Cores */}
                  <circle cx="25" cy="15" r="12" fill="#1a73e8"/>
                  <circle cx="55" cy="15" r="12" fill="#ec4899"/>
                  <circle cx="85" cy="15" r="12" fill="#8b5cf6"/>
                  <circle cx="115" cy="15" r="12" fill="#f59e0b"/>
                  <circle cx="145" cy="15" r="12" fill="#10b981"/>
                  <text x="175" y="20" fill="#64748b" fontSize="12">Paleta de cores</text>
                </g>
                
                <g transform="translate(20, 245)">
                  {/* Formas */}
                  <rect x="5" y="5" width="20" height="20" rx="2" fill="#e0e7ff" stroke="#6366f1" strokeWidth="2"/>
                  <circle cx="50" cy="15" r="10" fill="#fce7f3" stroke="#ec4899" strokeWidth="2"/>
                  <rect x="70" y="5" width="20" height="20" rx="10" fill="#fef3c7" stroke="#f59e0b" strokeWidth="2"/>
                  <text x="105" y="20" fill="#64748b" fontSize="12">Estilos de pontos</text>
                </g>
                
                <defs>
                  <linearGradient id="headerGrad2" x1="0" y1="0" x2="360" y2="0">
                    <stop offset="0%" stopColor="#fef3c7"/>
                    <stop offset="100%" stopColor="#fed7aa"/>
                  </linearGradient>
                  <linearGradient id="qrGrad" x1="10" y1="10" x2="110" y2="110">
                    <stop offset="0%" stopColor="#1a73e8"/>
                    <stop offset="100%" stopColor="#6366f1"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>

          {/* Step 3 - Download */}
          <div className="how-visual-step">
            <div className="how-visual-content">
              <div className="how-visual-number">03</div>
              <h3 className="how-visual-step-title">Baixe e compartilhe</h3>
              <p className="how-visual-step-desc">
                Pronto! Seu QR Code está criado. Faça o download em alta qualidade nos formatos PNG, SVG ou PDF. 
                Salve no histórico para editar depois ou compartilhe diretamente.
              </p>
              <ul className="how-visual-features">
                <li>📥 Download em PNG, SVG e PDF</li>
                <li>💾 Salve no histórico automático</li>
                <li>🔄 Edite e baixe novamente quando quiser</li>
              </ul>
            </div>
            <div className="how-visual-screen">
              {/* Mockup da interface - Download */}
              <svg width="360" height="280" viewBox="0 0 360 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="360" height="280" rx="16" fill="#ffffff"/>
                <rect width="360" height="280" rx="16" stroke="#e0e7ff" strokeWidth="3"/>
                
                {/* Header */}
                <rect y="0" width="360" height="50" rx="16" fill="url(#headerGrad3)"/>
                <text x="20" y="30" fill="#1f6cd5" fontWeight="700" fontSize="18">Seu QR Code está pronto!</text>
                
                {/* QR Code final com badge de sucesso */}
                <g transform="translate(120, 65)">
                  <rect x="0" y="0" width="120" height="120" rx="12" fill="#f8fafc" stroke="#10b981" strokeWidth="3"/>
                  <rect x="10" y="10" width="100" height="100" rx="4" fill="#1f6cd5"/>
                  <rect x="20" y="20" width="25" height="25" rx="3" fill="#ffffff"/>
                  <rect x="75" y="20" width="25" height="25" rx="3" fill="#ffffff"/>
                  <rect x="20" y="75" width="25" height="25" rx="3" fill="#ffffff"/>
                  <circle cx="60" cy="60" r="15" fill="#ffffff"/>
                  
                  {/* Badge de sucesso */}
                  <circle cx="105" cy="15" r="18" fill="#10b981"/>
                  <path d="M98 15l5 5 9-9" stroke="#ffffff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                
                {/* Botões de download */}
                <g transform="translate(40, 205)">
                  <rect x="0" y="0" width="90" height="40" rx="10" fill="#1a73e8"/>
                  <text x="45" y="26" textAnchor="middle" fill="#ffffff" fontWeight="700" fontSize="14">PNG</text>
                  
                  <rect x="100" y="0" width="90" height="40" rx="10" fill="#f1f5fd" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="145" y="26" textAnchor="middle" fill="#1976d2" fontWeight="700" fontSize="14">SVG</text>
                  
                  <rect x="200" y="0" width="90" height="40" rx="10" fill="#f1f5fd" stroke="#e0e7ef" strokeWidth="2"/>
                  <text x="245" y="26" textAnchor="middle" fill="#1976d2" fontWeight="700" fontSize="14">PDF</text>
                </g>
                
                {/* Info adicional */}
                <text x="180" y="265" textAnchor="middle" fill="#10b981" fontWeight="600" fontSize="13">✓ Salvo no histórico</text>
                
                <defs>
                  <linearGradient id="headerGrad3" x1="0" y1="0" x2="360" y2="0">
                    <stop offset="0%" stopColor="#d1fae5"/>
                    <stop offset="100%" stopColor="#a7f3d0"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>

          {/* CTA Final */}
          <div className="how-visual-cta">
            <h3 className="how-visual-cta-title">Pronto para começar?</h3>
            <p className="how-visual-cta-text">Crie seu primeiro QR Code grátis agora mesmo!</p>
            <a href="/connect" className="how-visual-cta-btn">
              <span>Criar meu QR Code</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M5 10h10M10 5l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </section>

      <section className="section-where">
        <div className="inner">
          <h2 className="where-title">Ainda não sabe onde ou como utilizar seus QR Codes?</h2>
          <p className="where-subtitle">Não se preocupe! As possibilidades são diversas... Confira algumas delas:</p>
          <div className="where-grid">
            <div className="where-item">
              <span className="where-svg">{/* Cartão de visitas */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="6" y="14" width="44" height="28" rx="4" stroke="#fff" strokeWidth="3"/><rect x="12" y="20" width="10" height="8" rx="2" stroke="#fff" strokeWidth="2"/><rect x="26" y="28" width="18" height="4" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Cartões de Visitas</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Flyers e panfletos */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="12" y="10" width="20" height="36" rx="2" stroke="#fff" strokeWidth="3"/><rect x="24" y="16" width="20" height="28" rx="2" stroke="#fff" strokeWidth="3"/></svg>
              </span>
              <div className="where-label">Flyers e panfletos</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Adesivos e etiquetas */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="12" y="20" width="32" height="16" rx="4" stroke="#fff" strokeWidth="3"/><path d="M40 20l4 4-8 8-4-4" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Adesivos e Etiquetas</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Latas e garrafas */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="16" y="16" width="8" height="24" rx="4" stroke="#fff" strokeWidth="3"/><rect x="32" y="16" width="8" height="24" rx="4" stroke="#fff" strokeWidth="3"/></svg>
              </span>
              <div className="where-label">Latas e Garrafas</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Roupas e acessórios */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><path d="M14 22l14-8 14 8v16a4 4 0 01-4 4H18a4 4 0 01-4-4V22z" stroke="#fff" strokeWidth="3"/><rect x="22" y="30" width="12" height="8" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Roupas e Acessórios</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Embalagens de alimento */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="16" y="24" width="24" height="16" rx="4" stroke="#fff" strokeWidth="3"/><rect x="20" y="32" width="8" height="8" rx="2" stroke="#fff" strokeWidth="2"/><rect x="28" y="32" width="8" height="8" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Embalagens de Alimento</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Banners */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="14" y="12" width="28" height="32" rx="4" stroke="#fff" strokeWidth="3"/><rect x="18" y="16" width="20" height="24" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Banners</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Outdoors */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="10" y="24" width="36" height="12" rx="3" stroke="#fff" strokeWidth="3"/><rect x="16" y="36" width="4" height="8" rx="2" stroke="#fff" strokeWidth="2"/><rect x="36" y="36" width="4" height="8" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Outdoors</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Livros */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="16" y="16" width="24" height="24" rx="4" stroke="#fff" strokeWidth="3"/><rect x="24" y="20" width="8" height="16" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Livros</div>
            </div>
            <div className="where-item">
              <span className="where-svg">{/* Jornais e revistas */}
                <svg width="56" height="56" viewBox="0 0 56 56" fill="none"><rect x="12" y="16" width="32" height="24" rx="4" stroke="#fff" strokeWidth="3"/><rect x="18" y="22" width="20" height="4" rx="2" stroke="#fff" strokeWidth="2"/><rect x="18" y="30" width="12" height="4" rx="2" stroke="#fff" strokeWidth="2"/></svg>
              </span>
              <div className="where-label">Jornais e Revistas</div>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFÍCIOS - NOVO ESTILO */}
      <section id="features" className="section-features">
        <div className="inner">
          <div className="features-header">
            <h2 className="features-title" style={{color:'#1f6cd5'}}>Por que escolher o QRCodeXpress?</h2>
            <p className="features-subtitle">Uma plataforma completa que combina tecnologia, design e segurança para transformar a forma como você cria e gerencia seus QR Codes</p>
          </div>
          <div className="features-grid">
            <div className="feature" style={{borderColor:'#1f6cd5'}}>
              <div className="feature-icon" style={{background:'#e0f7fa'}}>
                {/* Ilustração: Templates e Design */}
                <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Prancheta com QR Code estilizado */}
                  <rect x="56" y="40" width="144" height="176" rx="12" fill="#fff" stroke="#1f6cd5" strokeWidth="10"/>
                  {/* Grid QR Code */}
                  <rect x="80" y="64" width="32" height="32" rx="6" fill="#38bdf8"/>
                  <rect x="120" y="64" width="16" height="16" rx="4" fill="#0ea5e9"/>
                  <rect x="144" y="64" width="32" height="32" rx="6" fill="#1f6cd5"/>
                  <rect x="80" y="104" width="16" height="16" rx="4" fill="#0891b2"/>
                  <rect x="104" y="104" width="24" height="24" rx="4" fill="#6366f1"/>
                  <rect x="136" y="104" width="40" height="24" rx="4" fill="#8b5cf6"/>
                  <rect x="80" y="136" width="32" height="32" rx="6" fill="#a855f7"/>
                  <rect x="120" y="136" width="24" height="24" rx="4" fill="#d946ef"/>
                  <rect x="152" y="136" width="24" height="32" rx="4" fill="#ec4899"/>
                  {/* Ferramentas de design */}
                  <circle cx="96" cy="192" r="10" fill="#1f6cd5"/>
                  <circle cx="128" cy="192" r="10" fill="#0ea5e9"/>
                  <circle cx="160" cy="192" r="10" fill="#6366f1"/>
                </svg>
              </div>
              <h3 style={{color:'#1f6cd5'}}>Designs profissionais</h3>
              <p>Escolha entre dezenas de templates exclusivos, personalize cada detalhe dos módulos e olhos, e crie QR Codes que refletem perfeitamente a identidade visual da sua marca.</p>
            </div>
            <div className="feature" style={{borderColor:'#1f6cd5'}}>
              <div className="feature-icon" style={{background:'#e0e7ff'}}>
                {/* Ilustração: Logo com gradiente e pincel mágico */}
                <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="logoGrad" x1="64" y1="80" x2="192" y2="176" gradientUnits="userSpaceOnUse">
                      <stop offset="0%" stopColor="#38bdf8"/>
                      <stop offset="50%" stopColor="#6366f1"/>
                      <stop offset="100%" stopColor="#a855f7"/>
                    </linearGradient>
                  </defs>
                  {/* Frame com gradiente */}
                  <rect x="64" y="80" width="128" height="96" rx="16" fill="url(#logoGrad)" opacity="0.9"/>
                  {/* Logo simulado */}
                  <circle cx="128" cy="128" r="24" fill="#fff" opacity="0.95"/>
                  <path d="M128 112v32M112 128h32" stroke="#6366f1" strokeWidth="10" strokeLinecap="round"/>
                  {/* Pincel mágico com sparkles */}
                  <path d="M168 56l24 24-16 16-24-24z" fill="#1f6cd5" stroke="#1f6cd5" strokeWidth="6"/>
                  <circle cx="176" cy="48" r="6" fill="#fbbf24"/>
                  <circle cx="200" cy="56" r="4" fill="#fbbf24"/>
                  <circle cx="192" cy="72" r="4.8" fill="#fbbf24"/>
                  {/* Paleta de cores */}
                  <circle cx="80" cy="192" r="8" fill="#38bdf8"/>
                  <circle cx="104" cy="192" r="8" fill="#6366f1"/>
                  <circle cx="128" cy="192" r="8" fill="#a855f7"/>
                  <circle cx="152" cy="192" r="8" fill="#ec4899"/>
                </svg>
              </div>
              <h3 style={{color:'#1f6cd5'}}>Logos e Gradientes</h3>
              <p>Integre seu logotipo de forma inteligente, aplique gradientes sofisticados e exporte em resolução profissional otimizada tanto para impressão quanto para mídias digitais.</p>
            </div>
            <div className="feature" style={{borderColor:'#1f6cd5'}}>
              <div className="feature-icon" style={{background:'#e0f2fe'}}>
                {/* Ilustração: Cofre seguro com shield e histórico */}
                <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Shield de proteção */}
                  <path d="M128 48l-48 24v40c0 29.6 20.4 57.2 48 64 27.6-6.8 48-34.4 48-64v-40l-48-24z" fill="#38bdf8" stroke="#1f6cd5" strokeWidth="8"/>
                  <path d="M112 120l12 12 24-24" stroke="#fff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round"/>
                  {/* Documentos de histórico */}
                  <rect x="72" y="176" width="48" height="32" rx="6" fill="#fff" stroke="#1f6cd5" strokeWidth="6"/>
                  <line x1="80" y1="188" x2="112" y2="188" stroke="#0ea5e9" strokeWidth="6"/>
                  <line x1="80" y1="200" x2="104" y2="200" stroke="#0ea5e9" strokeWidth="6"/>
                  <rect x="136" y="176" width="48" height="32" rx="6" fill="#fff" stroke="#1f6cd5" strokeWidth="6"/>
                  <line x1="144" y1="188" x2="176" y2="188" stroke="#6366f1" strokeWidth="6"/>
                  <line x1="144" y1="200" x2="168" y2="200" stroke="#6366f1" strokeWidth="6"/>
                  {/* Cadeado */}
                  <circle cx="104" cy="136" r="6" fill="#fbbf24"/>
                  <circle cx="152" cy="136" r="6" fill="#fbbf24"/>
                </svg>
              </div>
              <h3 style={{color:'#1f6cd5'}}>Privacidade e Histórico</h3>
              <p>Seus dados estão protegidos com criptografia de ponta a ponta. Gerencie todo seu histórico de QR Codes em uma interface intuitiva, com total conformidade à LGPD brasileira.</p>
            </div>
            <div className="feature" style={{borderColor:'#1f6cd5'}}>
              <div className="feature-icon" style={{background:'#f0f9ff'}}>
                {/* Ilustração: QR Code sendo gerado com raios de velocidade */}
                <svg width="256" height="256" viewBox="0 0 256 256" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* QR Code central */}
                  <rect x="96" y="96" width="64" height="64" rx="8" fill="#fff" stroke="#1f6cd5" strokeWidth="8"/>
                  <rect x="104" y="104" width="16" height="16" rx="2" fill="#1f6cd5"/>
                  <rect x="128" y="104" width="8" height="8" rx="2" fill="#38bdf8"/>
                  <rect x="144" y="104" width="16" height="16" rx="2" fill="#1f6cd5"/>
                  <rect x="104" y="128" width="8" height="8" rx="2" fill="#6366f1"/>
                  <rect x="120" y="128" width="16" height="16" rx="2" fill="#38bdf8"/>
                  <rect x="104" y="144" width="16" height="16" rx="2" fill="#1f6cd5"/>
                  <rect x="128" y="144" width="8" height="8" rx="2" fill="#a855f7"/>
                  <rect x="144" y="144" width="16" height="16" rx="2" fill="#1f6cd5"/>
                  {/* Raios de velocidade */}
                  <path d="M72 80l-16-16M184 80l16-16M72 176l-16 16M184 176l16 16" stroke="#38bdf8" strokeWidth="10" strokeLinecap="round"/>
                  <path d="M56 128h-16M200 128h16M128 56v-16M128 200v16" stroke="#6366f1" strokeWidth="10" strokeLinecap="round"/>
                  {/* Partículas de velocidade */}
                  <circle cx="48" cy="112" r="6" fill="#fbbf24"/>
                  <circle cx="208" cy="144" r="6" fill="#fbbf24"/>
                  <circle cx="112" cy="40" r="6" fill="#fbbf24"/>
                  <circle cx="144" cy="216" r="6" fill="#fbbf24"/>
                  {/* Símbolo de raio */}
                  <path d="M128 72l-12 24h12v16l12-24h-12v-16z" fill="#fbbf24"/>
                </svg>
              </div>
              <h3 style={{color:'#1f6cd5'}}>Rápido e sem limites</h3>
              <p>Tecnologia de geração instantânea local que funciona até offline. Crie quantos QR Codes precisar, quando precisar, sem restrições arbitrárias ou taxas escondidas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PLANOS - NOVO VISUAL */}
      <section className="section-plans plans-impact">
        <div className="inner">
          <h2 className="plans-impact-title" style={{color:'#1f6cd5'}}>Planos para todos os perfis</h2>
          <p className="plans-impact-subtitle">Escolha o plano ideal para suas necessidades e comece a criar QR Codes profissionais hoje mesmo. Flexibilidade e transparência em cada opção.</p>
          <div className="plans-impact-grid">
            {/* Gratuito */}
            <div className="plan-impact-card plan-free">
              <div className="plan-impact-icon" style={{background:'#fef3c7'}}>
                {/* Ilustração: Presente/Gift box */}
                <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Caixa de presente */}
                  <rect x="32" y="56" width="64" height="48" rx="4" fill="#fff" stroke="#d97706" strokeWidth="4"/>
                  <rect x="28" y="48" width="72" height="16" rx="4" fill="#f59e0b" stroke="#d97706" strokeWidth="4"/>
                  {/* Laço */}
                  <rect x="60" y="32" width="8" height="72" rx="2" fill="#fbbf24"/>
                  <path d="M64 32c-12 0-16-8-16-16h32c0 8-4 16-16 16z" fill="#fbbf24"/>
                  {/* Estrelas decorativas */}
                  <circle cx="44" cy="72" r="3" fill="#fbbf24" opacity="0.6"/>
                  <circle cx="84" cy="80" r="3" fill="#fbbf24" opacity="0.6"/>
                  <circle cx="64" cy="88" r="2.5" fill="#fbbf24" opacity="0.6"/>
                  {/* Brilho */}
                  <circle cx="76" cy="60" r="2" fill="#fef3c7"/>
                  <circle cx="52" cy="68" r="2" fill="#fef3c7"/>
                </svg>
              </div>
              <div className="plan-impact-name">Grátis</div>
              <div className="plan-impact-price">R$ 0 <span>/mês</span></div>
              <ul className="plan-impact-features">
                <li>Crie e salve até 15 QR Codes sem expiração</li>
                <li>Designs customizáveis</li>
                <li>Exportação PNG/SVG/PDF</li>
                <li>Histórico pessoal</li>
              </ul>
              <a className="plan-impact-btn plan-free-btn" href="/connect">Usar Grátis</a>
            </div>
            {/* Pro */}
            <div className="plan-impact-card plan-pro highlight">
              <div className="plan-impact-icon" style={{background:'#dbeafe'}}>
                {/* Ilustração: Foguete/Rocket */}
                <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Corpo do foguete */}
                  <ellipse cx="64" cy="80" rx="16" ry="20" fill="#1e40af" stroke="#1e3a8a" strokeWidth="4"/>
                  <path d="M48 80v-48c0-8 7.2-16 16-16s16 8 16 16v48" fill="#3b82f6" stroke="#1e3a8a" strokeWidth="4"/>
                  {/* Ponta */}
                  <path d="M64 16l-16 16h32l-16-16z" fill="#1e40af" stroke="#1e3a8a" strokeWidth="4"/>
                  {/* Janela */}
                  <circle cx="64" cy="48" r="8" fill="#dbeafe" stroke="#1e3a8a" strokeWidth="3"/>
                  <circle cx="64" cy="48" r="4" fill="#60a5fa"/>
                  {/* Asas */}
                  <path d="M48 64l-16 24v8l16-16z" fill="#60a5fa" stroke="#1e3a8a" strokeWidth="3"/>
                  <path d="M80 64l16 24v8l-16-16z" fill="#60a5fa" stroke="#1e3a8a" strokeWidth="3"/>
                  {/* Fogo/propulsão */}
                  <ellipse cx="64" cy="100" rx="10" ry="8" fill="#fbbf24"/>
                  <ellipse cx="64" cy="108" rx="6" ry="6" fill="#f97316"/>
                  <circle cx="64" cy="112" r="3" fill="#fef3c7"/>
                  {/* Estrelas ao redor */}
                  <circle cx="40" cy="32" r="2" fill="#fbbf24"/>
                  <circle cx="88" cy="40" r="2.5" fill="#fbbf24"/>
                  <circle cx="92" cy="24" r="1.5" fill="#fbbf24"/>
                </svg>
              </div>
              <div className="plan-impact-name">Pro</div>
              <div className="plan-impact-price">R$ 19 <span>/mês</span></div>
              <ul className="plan-impact-features">
                <li>Todos recursos do Grátis</li>
                <li>Crie e salve até 100 QR Codes sem expiração</li>
                <li>QR Codes dinâmicos</li>
                <li>Estatísticas de acesso</li>
                <li>Remoção da marca d'água</li>
                <li>Suporte prioritário</li>
              </ul>
              <a className="plan-impact-btn plan-pro-btn" href="/connect">Assinar Pro</a>
            </div>
            {/* Business */}
            <div className="plan-impact-card plan-business">
              <div className="plan-impact-icon" style={{background:'#e0e7ff'}}>
                {/* Ilustração: Prédio corporativo */}
                <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Prédio principal */}
                  <rect x="40" y="32" width="48" height="72" rx="4" fill="#fff" stroke="#4338ca" strokeWidth="4"/>
                  {/* Topo do prédio */}
                  <rect x="36" y="24" width="56" height="12" rx="4" fill="#6366f1" stroke="#4338ca" strokeWidth="4"/>
                  {/* Janelas */}
                  <rect x="48" y="40" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="60" y="40" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="72" y="40" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="48" y="52" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="60" y="52" width="8" height="8" rx="1" fill="#8b5cf6"/>
                  <rect x="72" y="52" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="48" y="64" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="60" y="64" width="8" height="8" rx="1" fill="#6366f1"/>
                  <rect x="72" y="64" width="8" height="8" rx="1" fill="#6366f1"/>
                  {/* Porta */}
                  <rect x="56" y="88" width="16" height="16" rx="2" fill="#4338ca"/>
                  <circle cx="66" cy="96" r="1.5" fill="#fbbf24"/>
                  {/* Prédios menores ao fundo */}
                  <rect x="24" y="56" width="12" height="48" rx="2" fill="#c7d2fe" stroke="#6366f1" strokeWidth="2"/>
                  <rect x="92" y="64" width="12" height="40" rx="2" fill="#c7d2fe" stroke="#6366f1" strokeWidth="2"/>
                  {/* Detalhes decorativos */}
                  <circle cx="30" cy="68" r="1.5" fill="#6366f1"/>
                  <circle cx="30" cy="76" r="1.5" fill="#6366f1"/>
                  <circle cx="98" cy="76" r="1.5" fill="#6366f1"/>
                  <circle cx="98" cy="84" r="1.5" fill="#6366f1"/>
                </svg>
              </div>
              <div className="plan-impact-name">Business</div>
              <div className="plan-impact-price">R$ 49 <span>/mês</span></div>
              <ul className="plan-impact-features">
                <li>Tudo do Pro</li>
                <li>Gere até 100 QR Codes</li>
                <li>Ative e desative QR Codes</li>
                <li>QRCodes agendados</li>
                <li>Gestão multiusuário</li>
                <li>Personalização avançada</li>
                <li>Consultoria dedicada</li>
              </ul>
              <a className="plan-impact-btn plan-business-btn" href="/contato">Fale conosco</a>
            </div>
            {/* Donativo */}
            <div className="plan-impact-card plan-donate">
              <div className="plan-impact-icon" style={{background:'#fce7f3'}}>
                {/* Ilustração: Coração com mãos */}
                <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="heartGrad" x1="64" y1="32" x2="64" y2="96" gradientUnits="userSpaceOnUse">
                      <stop offset="0%" stopColor="#ec4899"/>
                      <stop offset="100%" stopColor="#be185d"/>
                    </linearGradient>
                  </defs>
                  {/* Coração */}
                  <path d="M64 96l-32-32c-8-8-8-20 0-28s20-8 28 0l4 4 4-4c8-8 20-8 28 0s8 20 0 28l-32 32z" 
                        fill="url(#heartGrad)" 
                        stroke="#be185d" 
                        strokeWidth="4"/>
                  {/* Brilho no coração */}
                  <ellipse cx="52" cy="48" rx="6" ry="8" fill="#fce7f3" opacity="0.6"/>
                  <circle cx="76" cy="56" r="3" fill="#fce7f3" opacity="0.5"/>
                  {/* Mãos apoiando */}
                  <path d="M32 72c-4 0-8 4-8 8v12c0 4 4 8 8 8h8v-28h-8z" fill="#f0abfc" stroke="#be185d" strokeWidth="3"/>
                  <path d="M96 72c4 0 8 4 8 8v12c0 4-4 8-8 8h-8v-28h8z" fill="#f0abfc" stroke="#be185d" strokeWidth="3"/>
                  {/* Sparkles */}
                  <circle cx="44" cy="28" r="2" fill="#fbbf24"/>
                  <circle cx="84" cy="32" r="2.5" fill="#fbbf24"/>
                  <circle cx="36" cy="56" r="1.5" fill="#fbbf24"/>
                  <circle cx="92" cy="60" r="1.5" fill="#fbbf24"/>
                  {/* Pulso (ondas) */}
                  <path d="M48 68l4-8 4 8 4-8" stroke="#fce7f3" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                  <path d="M64 68l4-8 4 8 4-8" stroke="#fce7f3" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
                </svg>
              </div>
              <div className="plan-impact-name">Donativo</div>
              <div className="plan-impact-price">Livre</div>
              <ul className="plan-impact-features">
                <li>Apoie o projeto QRCodeXpress</li>
                <li>Ajude a manter a plataforma gratuita</li>
                <li>Receba novidades e agradecimentos</li>
              </ul>
              <a className="plan-impact-btn plan-donate-btn" href="/connect">Fazer Donativo</a>
            </div>
          </div>
        </div>
      </section>

      {/* DEPOIMENTOS & CONFIANÇA */}
      <section className="section-testimonials">
        <div className="inner">
          <div className="testimonials-header">
            <h2 className="testimonials-title">Quem já usa, aprova</h2>
            <p className="testimonials-subtitle">
              Milhares de profissionais e empresas já transformaram sua comunicação com QR Codes personalizados. Veja o que eles têm a dizer.
            </p>
          </div>

          {/* Cards de Depoimentos */}
          <div className="testimonials-grid">
            {/* Depoimento 1 */}
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>⭐</span><span>⭐</span><span>⭐</span><span>⭐</span><span>⭐</span>
              </div>
              <p className="testimonial-text">
                "O QRCodeXpress revolucionou a forma como gerenciamos nossos materiais de marketing. 
                A personalização é incrível e a geração é instantânea. Ferramenta indispensável!"
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar" style={{background: 'linear-gradient(135deg, #6366f1, #8b5cf6)'}}>
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="12" r="5" fill="white"/>
                    <path d="M8 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="testimonial-info">
                  <div className="testimonial-name">Mariana Santos</div>
                  <div className="testimonial-role">Gerente de Marketing • TechCorp</div>
                </div>
              </div>
            </div>

            {/* Depoimento 2 */}
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>⭐</span><span>⭐</span><span>⭐</span><span>⭐</span><span>⭐</span>
              </div>
              <p className="testimonial-text">
                "Simples, rápido e extremamente profissional. Uso para cardápios digitais no meu restaurante 
                e os clientes adoram. A melhor ferramenta de QR Code que já usei!"
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar" style={{background: 'linear-gradient(135deg, #ec4899, #f43f5e)'}}>
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="12" r="5" fill="white"/>
                    <path d="M8 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="testimonial-info">
                  <div className="testimonial-name">Carlos Oliveira</div>
                  <div className="testimonial-role">Proprietário • Bistrô Sabor & Arte</div>
                </div>
              </div>
            </div>

            {/* Depoimento 3 */}
            <div className="testimonial-card">
              <div className="testimonial-stars">
                <span>⭐</span><span>⭐</span><span>⭐</span><span>⭐</span><span>⭐</span>
              </div>
              <p className="testimonial-text">
                "Como designer freelancer, preciso de ferramentas que entreguem qualidade e rapidez. 
                O QRCodeXpress supera todas as expectativas com templates lindos e customização total."
              </p>
              <div className="testimonial-author">
                <div className="testimonial-avatar" style={{background: 'linear-gradient(135deg, #1f6cd5, #0ea5e9)'}}>
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="16" cy="12" r="5" fill="white"/>
                    <path d="M8 28c0-4.4 3.6-8 8-8s8 3.6 8 8" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="testimonial-info">
                  <div className="testimonial-name">Juliana Ferreira</div>
                  <div className="testimonial-role">Designer Gráfica • Freelancer</div>
                </div>
              </div>
            </div>
          </div>

          {/* Badges de Confiança */}
          <div className="trust-section">
            <h3 className="trust-title">Confiado por diversos segmentos</h3>
            <div className="trust-badges">
              <div className="trust-badge">
                <div className="trust-badge-icon" style={{background: '#dbeafe'}}>
                  <svg width="40" height="40" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M64 20l8 24h24l-20 16 8 24-20-16-20 16 8-24-20-16h24z" fill="#1e40af" stroke="#1e3a8a" strokeWidth="4"/>
                    <circle cx="64" cy="64" r="36" stroke="#3b82f6" strokeWidth="6" fill="none"/>
                    <path d="M64 28v72M28 64h72" stroke="#93c5fd" strokeWidth="3"/>
                  </svg>
                </div>
                <div className="trust-badge-label">Startups</div>
              </div>
              <div className="trust-badge">
                <div className="trust-badge-icon" style={{background: '#e0e7ff'}}>
                  <svg width="40" height="40" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="44" y="48" width="40" height="56" rx="4" fill="#4f46e5" stroke="#4338ca" strokeWidth="4"/>
                    <rect x="52" y="64" width="8" height="8" rx="2" fill="#c7d2fe"/>
                    <rect x="68" y="64" width="8" height="8" rx="2" fill="#c7d2fe"/>
                    <rect x="52" y="80" width="8" height="8" rx="2" fill="#c7d2fe"/>
                    <rect x="68" y="80" width="8" height="8" rx="2" fill="#c7d2fe"/>
                    <rect x="56" y="88" width="16" height="16" rx="2" fill="#312e81"/>
                  </svg>
                </div>
                <div className="trust-badge-label">Empresas</div>
              </div>
              <div className="trust-badge">
                <div className="trust-badge-icon" style={{background: '#fef3c7'}}>
                  <svg width="40" height="40" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="32" y="48" width="64" height="56" rx="6" fill="#fbbf24" stroke="#f59e0b" strokeWidth="4"/>
                    <circle cx="48" cy="72" r="8" fill="#fef3c7"/>
                    <circle cx="80" cy="72" r="8" fill="#fef3c7"/>
                    <path d="M48 88h32" stroke="#78350f" strokeWidth="4" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="trust-badge-label">Comércio</div>
              </div>
              <div className="trust-badge">
                <div className="trust-badge-icon" style={{background: '#dcfce7'}}>
                  <svg width="40" height="40" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="36" y="36" width="56" height="56" rx="8" fill="#22c55e" stroke="#16a34a" strokeWidth="4"/>
                    <path d="M52 64l8 8 16-16" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="64" cy="64" r="28" stroke="#bbf7d0" strokeWidth="3" fill="none"/>
                  </svg>
                </div>
                <div className="trust-badge-label">Saúde</div>
              </div>
              <div className="trust-badge">
                <div className="trust-badge-icon" style={{background: '#fce7f3'}}>
                  <svg width="40" height="40" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="48" y="36" width="32" height="36" rx="4" fill="#ec4899" stroke="#be185d" strokeWidth="3"/>
                    <circle cx="64" cy="54" r="8" fill="#fce7f3"/>
                    <path d="M40 72h48l-8 32h-32z" fill="#be185d" stroke="#9f1239" strokeWidth="3"/>
                    <rect x="56" y="28" width="16" height="12" rx="2" fill="#9f1239"/>
                  </svg>
                </div>
                <div className="trust-badge-label">Educação</div>
              </div>
              <div className="trust-badge">
                <div className="trust-badge-icon" style={{background: '#f3e8ff'}}>
                  <svg width="40" height="40" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="40" y="52" width="48" height="36" rx="4" fill="#a855f7" stroke="#7e22ce" strokeWidth="4"/>
                    <rect x="56" y="44" width="16" height="8" rx="2" fill="#7e22ce"/>
                    <circle cx="60" cy="68" r="4" fill="#fae8ff"/>
                    <path d="M48 80h32M48 88h24" stroke="#fae8ff" strokeWidth="3" strokeLinecap="round"/>
                  </svg>
                </div>
                <div className="trust-badge-label">Profissionais</div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
